import src from "IMAGE";
export default { src, width: 1722, height: 282, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/ABUkYWEOGEFBDxpGRhAcS0wRHU1NEBxKSg0WOjoQG0hIYt4F9qW9CaQAAAAASUVORK5CYII="};
